import './suspense-fallback.scss';

import { useTranslation } from 'react-i18next';

/**
 * Пока грузится код страницы — тонкая полоска прогресса у верхнего края окна.
 * Экран не затемняется и не блокируется; на быстрых переходах полоска не успевает
 * появиться (задержка в CSS), поэтому не мигает.
 */
const SuspenseFallback: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="suspense-fallback"
      role="progressbar"
      aria-label={t('common.loading')}
      aria-busy="true"
    />
  );
};

export default SuspenseFallback;
